enum SubscriptionPrivilege {
  Monitoring = "Monitoring",
  MessageCenter = "MessageCenter",
  PerformanceTest = "PerformanceTest",
  Alerts = "Alerts",
  IntelligenceReports = "IntelligenceReports",
}

export default SubscriptionPrivilege
